$('button[data-toggle-question]').on('click', function(){
    $(this).parents('.question').toggleClass('is-active');
});